@if (event) {
  <div
    class="c-limitedTimeEventsLayout"
    theming
    [themingGroup]="LimitedTimeEventType[event.type]"
    themingAsset="background"
    [themingOverride]="event?.assets">
    @if (showCloseButton) {
      <slotcom-navigation-button
        type="close"
        rightPosition="5"
        (click)="closeModal()"></slotcom-navigation-button>
    }
    @if (showInfoButton) {
      <slotcom-navigation-button
        type="info"
        leftPosition="5"
        (click)="openInfo()"></slotcom-navigation-button>
    }
    <div class="c-limitedTimeEventsLayout__container">
      <div class="c-limitedTimeEventsLayout__left">
        <ng-content select="[left-container]"></ng-content>
      </div>
      <div class="c-limitedTimeEventsLayout__right">
        <ng-content select="[right-container]"></ng-content>
      </div>
    </div>
  </div>
}
